import { Component, OnInit, Injector } from '@angular/core';
import { ReportsService, Statuses } from '../reports.service';

@Component({
  selector: 'ga-wo-assigned-report-form',
  templateUrl: './ga-wo-assigned-report-form.component.html',
  styleUrls: ['../../../dialogs/ga-wo-submit-report-dialog/ga-wo-submit-report-dialog.component.scss',
    '../../../../work-orders.component.scss']
})
export class GaWoAssignedReportFormComponent implements OnInit {
  service: ReportsService;

  constructor(injector: Injector) {
    this.service = injector.get(ReportsService);
    this.service.status = Statuses.Assigned;
  }

  ngOnInit() {
    this.service.editForm.get('ActualStartDate').setValue(new Date());
    Promise.all([
      this.service.getStatuses(Statuses.Assigned),
      this.service.getDefaultContacts(),
      this.service.populateContactsList()
    ]);
  }
}
